import React, {Dispatch, SetStateAction, useMemo} from 'react';

import {ProductType} from '@br/idm-api';

import {useProductTypeNames} from '../../i18n';

import SelectFilter from './SelectFilter';

const ProductTypeFilter = <K extends string, F extends Partial<Record<K, ProductType>>>({
    label,
    field,
    filters,
    setFilters,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
}): JSX.Element => {
    const productTypeNames = useProductTypeNames();
    const options = useMemo(
        () => Object.entries(productTypeNames).map(([key, value]) => ({value: key as ProductType, label: value})),
        [productTypeNames]
    );
    return (
        <SelectFilter
            data-testid="product-type-filter"
            label={label}
            field={field}
            filters={filters}
            setFilters={setFilters}
            options={options}
        />
    );
};

export default ProductTypeFilter;
